import { Div, P, RenderBrandType, Separator } from '@vgrubs/components';
import { ActiveBrandEntity, Brand } from 'components/src/types/brand.types';
import { BrandImageComponent } from './BrandImageComponent';

export const BrandComponent = ({
  brand,
  onClick,
  showType = false,
  children,
}: {
  brand: Brand | ActiveBrandEntity;
  onClick: () => void;
  showType?: boolean;
  children?: React.ReactNode;
}) => {
  return (
    <Div
      $box
      $p="20px 24px"
      $flex
      $column
      $alignCenter
      $pointer
      onClick={onClick}
    >
      <BrandImageComponent image={brand.imageUrl} />
      <Separator $m="16px 0" />
      <P $bold $center $mb="0" $capitalize>
        {brand.name}
      </P>
      {showType && <P $mb="0">{RenderBrandType((brand as Brand).type)}</P>}
      {children}
    </Div>
  );
};
